import styled from 'styled-components'
import Button from '@mui/material/Button';

import { SPACING } from "ggx-componentlibrary/design/spacing/spacing.constants"
import { COLOR } from 'ggx-componentlibrary/design/color/color.constants'
import { Body } from "ggx-componentlibrary/design/typography/typography.styles"

const OpenShareMenuContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${SPACING.XS};
  cursor: pointer;
  border-radius: 4px;
  padding: 4px;
  ${props => props.$open ? `background-color: ${COLOR.GREY_LIGHTER};` :''};
  transition: all 150ms ease;
  &:hover {
    background-color: ${COLOR.GREY_LIGHTER};
  }
`

const ShareMenuItem = styled(Button)`
  height: ${SPACING.XL2};
  padding: ${SPACING.S};
  text-transform: none;
  border-radius: 0;
  justify-content: left;

  &:hover {
    background-color: ${COLOR.GREY_LIGHTER};
  }

  a {
    text-decoration: none;
  }
`

const StyledBody = styled(Body)`
  height: ${SPACING.XL2};
  padding: ${SPACING.S};
  cursor: default;
  opacity: ${({disabled}) => disabled ? '0.38' : '1' }; 
`

export {
  ShareMenuItem,
  StyledBody,
  OpenShareMenuContainer,
}